module.exports = {
	"A_BdE_homologated_company": "Company homologated by the Banco de España",
	"About_BARNATASA": "About BARNA-TASA, S.A.",
	"About_text_01": "BARNA-TASA is an Appraisal Company, homologated by the Banco de España, inscribed in the Official Register of Appraisal Entities with nº 4.470 and registration date: June 26th 1.995",
	"About_text_02": "The company is formed by a group of architects, engineers and specialists in the real estate appraisal and valuation field and count with a wide knowledge in the area, with more than 30 years of experience",
	"About_us": "About Us",
	"acc_Budget": "acc. Budget",
	"acc_appraisal_date": "acc. appraisal date",
	"Actions": "Actions",
	"Ad": "Ad",
	"Ads": "Ads",
	"Ad_address": "Address as stated in the ad",
	"Adaptability": "Adaptability",
	"Ad_code": "Ad code",
	"Ad_data_type": "Ad data type",
	"Ad_database_query": "Ad database query",
	"Ad_date": "Ad date",
	"Ad_type": "Ad type",
	"Add_address": "Add new address",
	"Add_appraisal": "Add appraisal",
	"Add_appraisal_file": "Add appraisal file",
	"Add_appraisal_report": "Add appraisal report",
	"Add_contact": "Add new contact",
	"Add_entity": "Add entity",
	"Add_email": "Add new email",
	"Add_market_study": "Add market study",
	"Add_real_estate": "Add real estate",
	"Add_room": "Add room",
	"Add_telephone_number": "Add new telephone number",
	"Add_to_comparables_list": "Add to comparables list",
	"Address": "Address",
	"Address_description": "Address description",
	"Addresses": "Adresses",
	"Adjusted_Comparison_Method": "Adjusted Comparison Method",
	"Adopted_age": "Adopted age",
	"Adopted_area": "Adopted area",
	"Adopted_building_market_value": "Adopted building market value",
	"Adopted_material_execution_cost": "Adopted material execution cost",
	"Adopted_material_execution_cost_deprecated_by_antiquity": "Adopted material execution cost deprecated by antiquity",
	"Adopted_value": "Adopted value",
	"Air_conditioning": "Air conditioning",
	"and": "and",
	"and_limit_date": "and limit date",
	"annexes": "annexes",
	"Annexes": "Annexes",
	"Age": "Age",
	"Agravation_or_improvement_coeficient": "Agravation or improvement coeficient",
	"Addressing_title": "Addressing title",
	"Advertisements_between_starting_date": "Advertisements between starting date",
	"appraisal": "appraisal",
	"Appraisal": "Appraisal",
	"appraisal_company": "appraisal company",
	"appraisal_file": "appraisal file",
	"Appraisal_date": "Appraisal date",
	"Appraisal_description": "Appraisal description",
	"Appraisal_file": "Appraisal file",
	"Appraisal_files": "Appraisal files",
	"Appraisal_file_description": "Appraisal file description",
	"Appraisal_files_index": "Appraisal files index",
	"Appraisal_purpose": "Appraisal purpose",
	"appraisal_report": "appraisal report",
	"Appraisal_report": "Appraisal report",
	"Appraisal_report_description": "Appraisal report description",
	"Appraisal_reports": "Appraisal reports",
	"Appraisal_petitioner": "Appraisal petitioner",
	"Appraisal_petitioners": "Appraisal petitioners",
	"Appraisal_Requests": "Appraisal Requests",
	"Appraisal_type": "Appraisal type",
	"Appraisal_total_value_determination": "Appraisal total value determination",
	"Appraisal_value": "Appraisal value",
	"Appraisals": "Appraisals",
	"Appraisals_and_valuations": "Appraisals and valuations",
	"Appraisals_Index": "Appraisals Index",
	"Appraisals_for_all_purposes": "Appraisals for all purposes",
	"Appraisals_of_the_Real_Estate": "Appraisals of the Real Estate",
	"Appraised": "Appraised",
	"Appraised_real_estates": "Appraised Real Estates",
	"Appraised_real_estates_in_this_report": "Real Estates appraised in this report",
	"Appraised_real_estate": "Appraised Real Estate",
	"Appraiser": "Appraiser",
	"Approximate_property_area": "Approximate property area",
	"Area": "Area",
	"Areas": "Areas",
	"areas": "areas",
	"Are_you_sure_q": "Are you sure?",
	"As_new_construction_cost": "As new Construction Cost",
	"Assets_value_update": "Assets value update",
	"Assurance": "Assurance",
	"at": "at",
	"Auditors": "Auditors",
	"average": "average",
	"Average": "Average",
	"Back_home": "Back home",
	"Back_to_safety": "Back to safety",
	"Bare_ownership": "Bare ownership",
	"Bare_ownership_value": "Bare ownership value",
	"Barnatasa_cover_short_description": "Company specialized in Valuations and Appraisals",
	"Barnatasa_header": "BARNA-TASA, S.A. registered in the Official Registry of Appraisal Entities from the Banco de España with number 4.470. Inscription date: 26/06/1.995",
	"Barnatasa_footer": "End of page. Reverse unusable. Any annotation on the back is null and without effect.",
	"Barnatasa_header_portrait": "BARNA-TASA, S.A. registered in the Official Registry of Appraisal Entities from the Banco de España with nº 4.470, Date 26/06/1995. Reg. Merc. Barcelona, Page 12, Volume 28.173 Page B-132.666, TIN A-60840543",
	"Bathrooms": "Bathrooms",
	"Bathrooms_number": "Bathrooms number",
	"BdE_code": "BdE code",
	"Bedrooms": "Bedrooms",
	"Bedrooms_number": "Bedrooms nº",
	"Block": "Block",
	"Building_Surveys": "Building surveys",
	"Buildings": "Buildings",
	"Buildings_useful_life": "Building's useful life",
	"Built_area": "Built area",
	"Budget_request": "Budget request",
	"Builders_general_expenses_percentage": "Builder's general expenses percentage",
	"Builders_general_expenses": "Builder's general expenses",
	"Builders_expenses_and_benefit_percentage": "Builder's expenses and benefit percentage",
	"Builders_expenses_and_benefit": "Builder's expenses and benefit",
	"Builders_industrial_benefit_percentage": "Builder's industrial benefit percentage",
	"Builders_industrial_benefit": "Benefici industrial del constructor",
	"Building_market_value": "Building market value",
	"real_estate_under_construction": "building under construction",
	"by": "by",
	"By": "By",
	"Cadastral_area": "Cadastral area",
	"Cadastral_data_check": "Cadastral data check",
	"Cadastral_data": "Cadastral data",
	"Cadastral_List": "Cadastral List",
	"Cadastral_Map": "Cadastral Map",
	"Cadastral_reference": "Cadastral reference",
	"Cadastral_Reference_less_20_positions_error_text": "The Cadastral Reference has less than 20 positions",
	"Calculate_values": "Calculate values",
	"Calendar": "Calendar",
	"Cancel": "Cancel",
	"Capture_date": "Capture date",
	"Catalan": "Catalan",
	"Census_section": "Census section",
	"Census_section_code": "Census section code",
	"certificates": "certificates",
	"cession": "cession",
	"Cession": "Cession",
	"Cession_contract_period_years": "Contract period in years",
	"Cession_contract_remaining_years": "Remaning contract years",
	"Cession_contract_start_date": "Contract start date",
	"Cession_gross_monthly_income": "Rent gross monthly income",
	"Cession_gross_yearly_income": "Rent gross yearly income",
	"Cession_net_yearly_income": "Rent net yearly income",
	"Clients_text_01": "BARNA-TASA, S.A. has an extensive client portfolio and works with all kinds of clients, both from the private and public sector. To be mentioned",
	"Clients_text_02": "BARNA-TASA S.A. offers a wide range of services aimed at assisting in decision-making regarding the valuation and verification of the real estate and other assets",
	"Clients_text_03": "The aim of BARNA-TASA, S.A. is to provide support to the clients of the best national and international law firms and auditors in those operations that require a real estate valuation. From a valuation for an expropriation process to the necessary valuations in merger and acquisition operations, advice on asset divestment and restructuring, covering any sector",
	"Clients_text_04": "A business environment like the current one generates the necessity to undertake complex projects and, at the same time, key decision making every day for the enterprises. Knowing this circumstances, BARNA-TASA S.A. offers its experience, professionalism and market knowledge to both small and big sized companies and financial institutions through a wide range of services, ensuring a personalized and professional treatment",
	"closed": "closed",
	"Changes_will_be_lost_p_continue_q": "Changes will be lost. Continue?",
	"Checks": "Checks",
	"Checks_performed": "Performed checks",
	"Code": "Code",
	"Commercial_premises": "Commercial premises",
	"Commission": "Commision",
	"Commitment": "Commitment",
	"Company_code": "Company code",
	"Company_or_business_name": "Company or business name",
	"Comparable_database_query": "Comparable database query",
	"Comparable_type": "Type of comparable",
	"comparables": "comparables",
	"Comparables": "Comparables",
	"Comparison_Method": "Comparison Method",
	"Confidentiality": "Confidentiality",
	"Confirm_Password": "Confirm Password",
	"Conservation": "Conservation",
	"Conservation_status": "Conservation status",
	"Constant_income_with_CPI_update_clause": "Constant income with Consumer Price Index update clause",
	"construction": "construction",
	"Construction": "Construction",
	"Construction_cost": "Construction cost",
	"Construction_cost_and_development_expenses": "Construction cost and development expenses",
	"Construction_cost_by_contract": "Construction cost by contract",
	"Construction_costs": "Construction costs",
	"Construction_progress_percentage": "Construction progress percentage",
	"Construction_replacement_cost": "Construction replacement cost",
	"Construction_value": "Construction value",
	"construction_year": "construction year",
	"Construction_year": "Construction year",
	"Contact": "Contact",
	"Contact_data": "Contact data",
	"Contact_Data": "Contact Data",
	"Contact_file": "Contact file",
	"Contact_name": "Contact name",
	"Contact_telephone": "Contact telephone",
	"Contacts": "Contacts",
	"Contacts_Index": "Contacts Index",
	"contained_in_this_file": "contained in this file",
	"contained_in_this_file_f": "contained in this file",
	"Continue_q": "Continue?",
	"Contracts_foreseeable_remaining_period": "Contract's foreseeable remaining period",
	"Cooperatives": "Cooperatives",
	"Corrected_market_value": "Corrected market value",
	"Corrected_unit_market_value": "Corrected unit value",
	"Correction": "Correction",
	"Correction_of_values": "Correction of values",
	"Cost_method": "Cost method",
	"Council_classification": "Council Classification",
	"Council_classification_description": "Council Classification Description",
	"Council_qualification": "Council Qualifitacion",
	"Council_qualification_description": "Council Qualification Description",
	"Regional_classification": "Regional Classification",
	"Regional_classification_description": "Regional Classification Description",
	"Regional_qualification": "Regional Qualification",
	"Regional_qualification_description": "Regional Qualification Description",
	"Country": "Country",
	"Country_s_State": "Country / State",
	"Covered_outdoor_area": "Covered outdoor area",
	"Create_a_new_contact": "Create a new contact",
	"Created": "Created",
	"Creation": "Creation",
	"Current_reversion_value_calculation": "Current reversion value calculation",
	"Current_value_of_future_rents": "Current value of future rents",
	"Customer_Service": "Customer Service",
	"Customer_Service_text_01": "offers the clients their",
	"Customer_Service_text_02": "to which they can direct their suggestions and complaints in accordance to the service provided by the Company",
	"Customer_Service_text_03": "The functions of the CS are",
	"Customer_Service_text_04": "Attend and address the complaints and inquires which are presented, directly or through representation, by natural or legal persons, national or foreigners, clients of the Company, whenever they reference the interests or rights that are legally acknowledged to be related with the operations, contracts or services provided by the company, both if they derivate from the main contracts or the regulations for the transparency, client protection or good practices and uses, in particular with the equity principle",
	"Customer_Service_text_05": "Deliver to the directorate of the company all the recommendations and suggestions that, in their opinion, will improve the good relationship and mutual trust that should exist between the company and its clients",
	"Customer_Service_text_06": "The information duties of this CS are reflected in the current legislation Orden ECO/734/2004, from march 11th, about the departments and customer services of the financial entities",
	"Customer_Service_text_07": "Access to the Customer Service Regulations from BARNA-TASA, S.A.",
	"Customer_Service_text_08": "Access to the claims sheet",
	"Customer_Service_text_09": "Applicable legislation for the defense of the client of financial services",
	"Customer_Service_text_10": "Law 2/2011 from march 4th of Sustainable Economy",
	"Customer_Service_text_11": "ECC/2502/2012 from November 16th",
	"Customer_Service_text_12": "ECO/734/2004 from March 11th",
	"Customer_Service_text_13": "You can contact us trough the following options",
	"Customer_Service_text_14": "In person, in the Customer Service office (from 10:00 to 13:00 and from 16:00 to 19:00). Address",
	"Customer_Service_text_15": "By certified mail, addressed to",
	"Customer_Service_text_16": "A complaint form is available to the customers, that you will found in this",
	"Customer_Service_text_17": "The form is voluntary and will contain the following information",
	"Customer_Service_text_18": "Name and Surnames of the interested",
	"Customer_Service_text_19": "Domicile address of the interested (and if applicable, the address of the representative)",
	"Customer_Service_text_20": "Natural persons: the Tax Identification Number of the interested",
	"Customer_Service_text_21": "Legal persons: the Tax Identification Number and the Commercial Registry data",
	"Customer_Service_text_22": "Reason for the complaint, clearly specifying the issues on which a ruling is requested",
	"Customer_Service_text_23": "Número de expediente de tasación",
	"Customer_Service_text_24": "Lugar, fecha y firma",
	"Customer_Service_text_25": "Documentary evidence (if it is applicable)",
	"Customer_Service_text_26": "In the event of exhausting all the avaiable routes through the Customer Service (denied, dismissed or more than two months elapsed without resolution), a complaint may be filed in the Departamento de Conducta de Mercado y Reclamaciones of the Banco de España whose contact details are",
	"Customer_Service_text_27": "Or online through the virtual office",
	"Data": "Data",
	"Data_tabulation": "Data tabulation",
	"date": "date",
	"Date": "Date",
	"Data_of_property_to_be_appraised": "Data of property to be appraised",
	"Date_of_the_appraisal_value": "Date of the appraisal value",
	"Date_of_report": "Date of report",
	"Date_of_quote": "Date of quote",
	"Date_of_invoice": "Date of invoice",
	"Delete": "Delete",
	"Deprecated_construction_cost": "Deprecated construction cost",
	"Depreciation_by_antiquity": "Depreciation by antiquity",
	"description": "description",
	"Description": "Description",
	"Discard": "Discard",
	"Distance": "Distance",
	"Door": "Door",
	"Duplicate": "Duplicate",
	"Dwellings": "Dwellings",
	"Dwelling_type": "Tipo de vivienda",
	"e-mail": "e-mail",
	"E-mail": "E-mail",
	"E-mail_address": "E-mail address",
	"E-mail_addresses": "E-mail addresses",
	"E-mail_description": "E-mail description",
	"Email": "E-mail",
	"Email address": "E-mail address",
	"Edit": "Edit",
	"Edit_ad": "Edit ad",
	"Edit_address": "Edit address",
	"Edit_Appraisal": "Edit appraisal",
	"Edit_real_estate": "Edit real estate",
	"Edit_Real_Estate": "Edit Real Estate",
	"Edit_contact": "Edit contact",
	"Email_Address": "E-mail Address",
	"Energy_Certificates": "Energy Certificates",
	"Energy_Efficiency_Certificate": "Energy Efficiency Certificate",
	"Entities": "Entities",
	"Entities_Index": "Entities Index",
	"Entity": "Entity",
	"EPSG_missing_text": "Coordinates X and Y EPSG:25831 are missing. They are necessary in order to retrieve the cadastral and census section data. They can be obtained pressing the Geolocate button",
	"Estimated_sale_price": "Estimated sale price",
	"Estimated_unit_sale_price": "Estimated unit price",
	"Estimated_useful_life": "Estimated useful life",
	"Executed_construction_cost": "Executed construction cost",
	"Expected_Income_Update_Method": "Expected Income Update Method",
	"Experience": "Experience",
	"Experience_text": "More than 30 years of experience offering the best service at the best price",
	"Expert_Opinions": "Expert Opinions",
	"expert_opinions": "expert opinions",
	"Expropriations": "Expropriations",
	"External_storage_room": "Storage room",
	"features": "features",
	"Features": "Features",
	"Fees": "Fees",
	"file": "file",
	"File": "File",
	"File_description": "File description",
	"Files": "Files",
	"File_number": "File nº",
	"Final_unit_price": "Final unit price",
	"Financial_Entities": "Financial Entities",
	"finished_real_estate": "Finished Real Estate",
	"finishes": "finishes",
	"Finishes": "Finishes",
	"fixtures": "fixtures",
	"Fixtures": "Fixtures",
	"Fiscal_Address": "Fiscal Address",
	"Fiscal_address": "Fiscal address",
	"Floor": "Floor",
	"Floor_number": "Floor nº",
	"Floor_type": "Floor type",
	"For_all_purposes": "For all purposes",
	"Foundations": "Foundations",
	"Freemarket_benefit": "Free-market benefit",
	"Fri.": "Fri.",
	"from": "from",
	"Functional_depreciation": "Functional depreciation",
	"General_data": "General data",
	"Green_areas": "Garden / Green areas",
	"Have_an_account_q_Log_in": "Have an account? Log in",
	"Heating": "Heating",
	"Height_situation": "Height situation",
	"Higher_values": "Higher values",
	"Home_text_01": "Official Appraisal Company, from 1995, in the Official Register for Appraisal Entities of the Banco de España",
	"homogenisation": "homogenisation",
	"Homogenisation": "Homogenisation",
	"Homogenisation_of_values": "Homogenisation of values",
	"Homologated_Appraisal_Company_c_since_1995": "Homologated Appraisal Company, since 1995",
	"Homologated_company": "Homologated company",
	"Homologated_text_01_part01": "Company inscribed in the",
	"Homologated_text_01_part02": "of Appraisal Entities of the Banco de España, with nº 4470 and date 26/06/1995",
	"Honorarium_c_taxes_and_licenses": "Honorarium, taxes and licenses",
	"Honorarium_c_taxes_and_licenses_percentage": "Honorarium, taxes and licenses percentage",
	"Hospitals": "Hospitals",
	"Hotels": "Hotels",
	"Decennial_insurance_policy_expenses": "Decennial insurance policy expenses",
	"Decennial_insurance_policy_expenses_percentage": "Decennial insurance policy expenses percentage",
	"Developers_administrative_expenses": "Developer's administrative expenses",
	"Developers_administrative_expenses_percentage": "Developer's administrative expenses percentage",
	"Developers_benefit": "Developer's benefit",
	"Development_expenses": "Development expenses",
	"Development_expenses_percentage": "Development expenses percentage",
	"Geographical_area": "Geographical area",
	"Geolocate": "Geolocate",
	"Identification": "Identification",
	"go_back": "go back",
	"Go_back": "Go back",
	"go_up": "go up",
	"Go_up": "Go up",
	"Gross_Replacement_Cost": "Gross Replacement Cost",
	"Gross_yearly_rent_income": "Gross yearly rental income",
	"in_01": "in",
	"In_accordance_with_eco_decree_q": "In acc. with ECO Decree?",
	"In_accordance_with_mortgage_market_law_q": "In acc. with Mortgage Market Law?",
	"Independence": "Independence",
	"Independent_professionals": "Independent professionals",
	"Independent_pl": "Independent",
	"Index_of_Appraisals": "Index of Appraisals",
	"Individuals": "Individuals",
	"Industrial_warehouses": "Industrial warehouses",
	"Info_source": "Information source",
	"Infrastructures": "Infrastructures",
	"Paving_execution_pct": "Paving execution percentage",
	"Sewage_execution_pct": "Sewage execution percentage",
	"Public_lighting_execution_pct": "Public lighting execution percentage",
	"Water_supply_execution_pct": "Water supply execution percentage",
	"Electricity_supply_execution_pct": "Electricity supply execution percentage",
	"Piped_gas_execution_pct": "Piped gas execution percentage",
	"Telephone_service_execution_pct": "Telephone service execution percentage",
	"Gardened_areas_execution_pct": "Gardened areas execution percentage",
	"Total_execution_pct": "Infrastructures total execution percentage",
	"Infrastructures_repercussion_cost": "Infrastructures repercussion cost",
	"Pending_investment": "Pending investment",
	"Paving": "Paving",
	"Sewage": "Sewage",
	"Public_lighting": "Public lighting",
	"Electricity_supply": "Electricity supply",
	"Piped_gas": "Piped gas",
	"Telephone_service": "Telephone service",
	"Gardened_areas": "Gardened areas",
	"Land_is_plot_according_to_law": "Is the terrain considered a plot according to the Ley del Suelo?",
	"Notes_on_plot_infrastructures": "Notes on the infrastructures",
	"Notes_on_plot_area": "Notes on the area of the terrain",
	"Informative_Appraisal_Fees": "Informative Appraisal Fees",
	"Initial_Data": "Initial Data",
	"Initial_unit_price": "Initial unit price",
	"Innovation": "Innovation",
	"Insurance_companies": "Insurance companies",
	"Insurance_value": "Insurance value",
	"Interior_visit_check": "Interior visit check",
	"Internal_regulation": "Internal regulation",
	"Invalid_email_address": "Invalid email address",
	"Investment_groups": "Investment groups",
	"Invoices": "Invoices",
	"Is_it_rented_or_ceded_q": "Is the Real Estate rented or ceded?",
	"Is_the_real_estate_protected_q": "Is the Real Estate protected?",
	"Is_the_right_of_use_ceded_q": "Is the Real Estate's right of use ceded?",
	"land": "land",
	"Land": "Land",
	"Land_area": "Land area",
	"Land_registry_area": "Land registry area",
	"Land_pl": "Land",
	"Land_total_value": "Land total value",
	"Land_value": "Land value",
	"Land_value_plus_deprecated_construction_cost": "Land value plus deprecated construcion cost",
	"Land_value_plus_executed_construction_cost": "Land value plus executed construcion cost",
	"Landlord_expenses_pct": "Remaining net income percentage due to landlord's expenses",
	"Language": "Language",
	"Last_modified": "Last modified",
	"last_renovation_year": "last renovation year",
	"Last_renovation_year": "Last renovation year",
	"Appraisal_adopted_area_missing_error_text": "The built area of the appraised property is missing",
	"Appraisal_property_type_missing_error_text": "The property type is missing",
	"Lat_lng_missing_error_text": "The coordinates (latitude and longitude) for the real estate are missing",
	"Ad_type_missing_error_text": "The ad type is missing",
	"Date_missing_error_text": "The dates are missing",
	"Adopted_age_missing_error_text": "Adopted age is missing",
	"Adopted_age_length_error_text": "Adopted age should be a year, and have the format 'YYYY'",
	"Adopted_area_missing_error_text": "Built area is missing",
	"Property_type_missing_error_text": "Realestate type is missing",
	"Land_market_value": "Land market value",
	"Latitude": "Latitude",
	"Law_firms": "Law firms",
	"Lift": "Lift",
	"link": "link",
	"Loading": "Loading",
	"Log_In": "Log In",
	"Longitude": "Longitude",
	"Looking_for_something_q": "Looking for something?",
	"Lower_limit": "Lower limit",
	"Machinery": "Machinery",
	"Market_coeficient": "Market coeficient",
	"Market_value_adjustment": "Market value adjustment",
	"Market_value_of_the_appraised_realestate": "Market value of the appraised realestate",
	"Market": "Market",
	"Market_calculations": "Market calculations",
	"Market_studies_for_this_real_estate": "Market studies for this real estate",
	"Market_study": "Market study",
	"Market_study_for": "Market study for",
	"Market_unit_value": "Market unit value",
	"Market_value": "Market value",
	"Market_value_reduction_pct": "Market value reduction (%)",
	"Market_studies": "Market studies",
	"Material_execution_cost": "Material execution cost",
	"Materials": "Materials",
	"Maximum_legal_computable_area": "Maximum legal computable area",
	"Maximum_legal_sale_price": "Maximum legal sale price",
	"Maximum_Legal_Method": "Maximum Legal Method",
	"Mec_adjustment_coef": "Adjustment coefficient of the material execution cost ",
	"Measurements": "Measurements",
	"Medical_centers": "Medical centers",
	"Messages": "Messages",
	"Metadata": "Metadata",
	"Minimum_benefit_acc_to_regulation": "Minimum benefit according to regulation",
	"Minimum_fees": "Minimum fees",
	"Modification": "Modification",
	"Modified": "Modified",
	"Mon.": "Mon.",
	"Mortgage_Appraisal_Fees": "Mortgage Appraisal Fees",
	"Municipality": "Municipality",
	"Mutual_insurance_companies": "Mutual insurance companies",
	"Name": "Name",
	"Name_and_surnames": "Name and surnames",
	"Name_and_TIN": "Name and Tax Identification Number",
	"net_area": "net area",
	"Net_area": "Net area",
	"Net_areas": "Net areas",
	"Net_Replacement_Cost": "Net Replacement Cost",
	"Net_yearly_rent_income": "Net yearly rental income",
	"New_address": "New address",
	"New_appraisal_file": "New appraisal file",
	"New_contact": "New contact",
	"New_entity": "New entity",
	"Number": "Number",
	"Number_of_floors_and_use": "Number of floors and use",
	"No_address_registered": "No address registered",
	"No_contact_registered": "No contact registered",
	"No_email_address_registered": "No email address registered",
	"No_telephone_number_registered": "No telephone number registered",
	"No_results": "No results",
	"Non_recoverable_taxes": "Non-recoverable taxes",
	"Non_recoverable_taxes_percentage": "Non-recoverable taxes percentage",
	"Not_found_message": "Page not found",
	"notes": "notes",
	"Notes": "Notes",
	"Notes_1": "Notes 1",
	"Notes_2": "Notes 2",
	"Notes_on_mortgage_valuation_validity": "Notes on the validity of the valuation for mortgage guarantees",
	"Occupancy_Card": "Occupancy Card",
	"Occupancy_Cards": "Occupancy Cards",
	"Occupancy_Card_and_Certificate": "Occupancy Card and Certificate",
	"Occupancy_Certificate": "Occupancy Certificate",
	"occupancy_certificates": "occupancy certificates",
	"of": "of",
	"of_the_excess_of": "of the excess of",
	"of_the_same_property": "of the same property",
	"Office_hours": "Office hours",
	"Offer_price": "Offer price",
	"Offer_unit_price": "Offer unit price",
	"Official_Appraisals": "Official Appraisals",
	"Official_appraisals_for_all_purposes": "Official appraisals for all purposes",
	"Official_Register": "Official Register",
	"Offices": "Offices",
	"Open": "Open",
	"Open_link_in_new_tab": "Open link in new tab",
	"Organization_s_Company": "Organization / Company",
	"Orientation": "Orientation",
	"Other_elements_included_in_this_valuation_price": "Other elements included in this valuation price",
	"Other_services": "Other services",
	"other_services": "other services",
	"others": "others",
	"Our_clients": "Our clients",
	"Our_services": "Our services",
	"Our_workflow": "Our workflow",
	"PA_registration_number": "PA reg. number",
	"Page_not_found": "Page not found",
	"Parking_lots_number": "Parking lots number",
	"Parking_spaces": "Parking spaces",
	"Password": "Password",
	"Person_type": "Person type",
	"Petitioner": "Petitioner",
	"Petitioner_data": "Petitioner data",
	"Petitioner_type": "Petitioner type",
	"Philosophy": "Filosofia",
	"Philosophy_text_01": "The company's vision can be summarized in three fundamental principles: professionalism, rapidity and ethics. All together with a good team of professionals and a thorough quality control",
	"Philosophy_text_02": "Our values define our identity as a company and constitute the driving force of how we do our work day by day. We believe that our success is a consequence of them, among which we highlight",
	"Philosophy_text_03": "Continuous auditing of our appraisal and valuation processes together with the use of the latest technologies. BARNA-TASA, S.A. has specially developed software for the valuation process using the most appropriate computer tools. All our reports include digital signature certification",
	"Philosophy_text_04": "It is a company whose shareholders and board of directors is private and NOT LINKED to any Financial Institution or real estate group. BARNA-TASA, S.A not intermediate in transactions of sale in the market, reason why its services lend themselves of the most absolute independence",
	"Philosophy_text_05": "Responsiveness, effectiveness and balance of our assessments. Commitment to fulfill the requirements and processes required for customer satisfaction",
	"Philosophy_text_06": "Our quality system is based on the following principles: Continuous improvement and improvement as a permanent objective, which is achieved especially through the commitment of the entire organization and the systematic analysis of quality results. To satisfy the needs and expectations of the customers, fulfilling the delivery times agreed with the clients and working on the improvement of them, always delivering a good product to the first one. Compliance with the requirements, whether regulatory and legal, particular of our clients or any other, thus giving response to all interested parties",
	"Philosophy_text_07": "Ensure compliance with current regulations and work well done",
	"Philosophy_text_08": "The fact that they are registered and registered with the number 4,470 in the Register of Valuation Companies of the Banco de España and subject to supervision, guarantees the strictness of objectivity and absolute transparency of our valuation reports",
	"Philosophy_text_09": "More than three decades in the field of appraisal endorse our work",
	"Philosophy_text_10": "The confidentiality of the work required by the regulations is guaranteed by the professional secrecy that governs the conduct of our technicians. BARNA-TASA S.A. Does not disclose information to third parties",
	"Philosophy_text_11": "BARNA-TASA, S. A. establishes a framework of conduct for society and its workers",
	"Physical_depreciation": "Physical depreciation",
	"Pick_an_option": "Pick an option",
	"Plan_type": "Planning type",
	"Please_enter_a_name": "Please enter a name",
	"Please_enter_a_surname": "Please enter a surname",
	"Please_enter_a_telephone_number": "Please enter a telephone number",
	"Please_enter_an_email_address": "Please enter an email address",
	"Please_enter_the_type_of_property": "Please enter the type of property",
	"Please_enter_the_address_of_the_property": "Please enter the address of the property",
	"Please_enter_the_postal_code": "Please enter the postal code",
	"Please_enter_the_municipality": "Please enter the municipality",
	"Please_enter_the_area_of_the_property": "Please enter the area of the property",
	"Please_enter_the_purpose_of_the_appraisal": "Please enter the purpose of the_appraisal",
	"Plot_area": "Plot area",
	"Postal_code": "Postal code",
	"Prefix": "Prefix",
	"Price": "Price",
	"Pricing": "Pricing",
	"Pricing_and_Quotes": "Pricing and Quotes",
	"Pricing_text_01": "We offer two types of valuations: the mortgage valuation and the informative valuation, according to its purpose",
	"Pricing_text_02": "You will get a written estimate of your valuation in a maximum of 24 hours, without any commitment",
	"Pricing_text_03": "Volume discount. APPLICABLE VAT: 21%",
	"Pricing_text_04": "Mortgage valuation: Regulated by ECO regulation 805/2003 and related provisions",
	"Pricing_text_05": "The locations outside Barcelona capital and metropolitan area will have transportation fees",
	"Pricing_text_06": "Special discount for the orders of the Taxation Report + Certificate of the same property",
	"Print_report_in_PDF": "Print report in PDF",
	"Private_Enterprises": "Private Enterprises",
	"Professional_association": "Prof. Association",
	"Professional_ethics": "Professional ethics",
	"Professional_qualification": "Prof. Qualification",
	"Professionalism": "Professionalism",
	"Professionals_text_01_part_01": "A company formed by",
	"Professionals_text_01_part_02": "fully independent architects, engineers and specialists",
	"Professionals_text_01_part_03": ", without any bounds to financial institutions or business groups of any kind",
	"Properties": "Properties",
	"Properties_under_economic_exploitation": "Properties under economic exploitation",
	"Property_data": "Property data",
	"Property_developers": "Property developers",
	"Property_purchase-sale": "Property purchase-sale",
	"Property_developments": "Property developments",
	"Property_type": "Property type",
	"Property_types": "Property types",
	"Property_valuation_services": "Property valuation services",
	"Property_visit": "Property visit",
	"protection": "protection",
	"Protection": "Protection",
	"Protection_type": "Protection type",
	"Protection_regime": "Protection regime",
	"Protection_zone": "Protection zone",
	"Province": "Province",
	"Public_Administrations": "Public Administrations",
	"purpose": "purpose",
	"Qualities": "Qualities",
	"Qualities_comparison": "Qualities comparison",
	"Quality": "Quality",
	"Quality_of_construction": "Construction quality",
	"Quality_of_neighbourhood": "Neighbourhood quality",
	"Quality_of_realestate": "Realestate quality",
	"Quality_of_situation": "Situation quality",
	"Query_comparables": "Query comparables",
	"Query_real_estates": "Query Real Estates",
	"Query_result": "Query result",
	"Quote_request": "Budget request",
	"Quotes": "Budgets",
	"Real_estate": "Real Estate",
	"Real_estates": "Real Estates",
	"Real_estates_index": "Real Estates index",
	"Real_Estates_residual_value": "Valor residual de l'immoble",
	"Real_estates_residual_value_at_the_end_of_the_contracts_useful_life": "Real Estate's residual value at the end of the contract's useful life",
	"Real_estate_referral": "Real Estate Referral",
	"Realestates_remaining_useful_life": "Real Estate's remaining useful life",
	"Real_estate_value": "Real Estate value",
	"RealEstate_description": "Real Estate description",
	"Reduction": "Reduction",
	"Reduction_pct": "Reduction (%)",
	"Registry_data": "Registry data",
	"Registry_identification_data": "Registry identification data",
	"Register_name": "Name of Register",
	"Regression_line": "Regression line",
	"Regression_line_calculation": "Regression line calculation",
	"Remaining_contract_years": "Remaining contract years",
	"Remaining_period_update": "Remanining period update",
	"Remaining_of_the_developers_benefit": "Remaining of the developers benefit",
	"Repercussion_method": "Repercussion method",
	"Report": "Report",
	"reports": "reports",
	"Report_content": "Report content",
	"Report_content_text_01": "Visit of the property and preparation of an official report by a qualified technician of BARNA-TASA",
	"Report_content_text_02": "Identification and location. Property specifications. Cadastral and Registry data",
	"Report_content_text_03": "Pictures and sketch of the property",
	"Report_content_text_04": "Real market study, sample selection and value calculation",
	"Report_date": "Report date",
	"Report_language": "Report language",
	"Requesting": "Requesting",
	"Report_number": "Report number",
	"Report_title": "Report title",
	"Report_title_missing_error_text": "The report title is missing",
	"Representative": "Representative",
	"representative_sample": "representative sample",
	"Representative_sample": "Representative sample",
	"Representative_TIN": "TIN of the representative",
	"Request_a_quote": "Request a quote",
	"Request_a_quote_24h": "Request a quote (24h)",
	"Request_a_quote_here": "Request a quote here",
	"Request_a_quote_for_an_appraisal": "Request a quote for an appraisal",
	"Request_successfully_sent": "Request successfully sent",
	"Required_fields": "Required fields",
	"Residual_depreciation": "Residual depreciation",
	"Residual_value": "Residual value",
	"Restaurants": "Restaurants",
	"Restricted": "Restricted",
	"Right_of_use": "Right of use",
	"Right_of_use_value": "Right of use value",
	"rights": "rights",
	"Rights": "rights",
	"Rigor": "Rigor",
	"Risk_premium": "Risk premium",
	"Riskfree_rate": "Risk-free rate",
	"Room": "Room",
	"Rooms": "Rooms",
	"Sat.": "Sat.",
	"Save": "Save",
	"Save_and_go_back": "Save and go back",
	"Save_valuation": "Save valuation",
	"Search_radius_km": "Search radius (km)",
	"Security": "Security",
	"Selected_comparables": "Selected comparables",
	"Send_to_bde_q": "Send to BdE?",
	"Services": "Services",
	"Services_text_01": "BARNA-TASA, S.A. Is a company specialized in ASSESSMENT OF GOODS, approved and registered in the Banco de España with the number 4,470 in the Official Registry of Appraisal Entities. Our experience is based on more than 30 years of professional exercise in the field of appraisals, valuations and construction surveys",
	"Services_text_02": "Our main service is framed in the field of valuations and appraisals for all purposes. We also offer a range of services related to the world of architecture and expertise, from the elaboration of construction reports and opinions to certificates, certificates and floor surveys",
	"Services_text_03": "We carry out appraisals for all purposes. We offer two types of appraisals according to their purpose",
	"Services_text_04": "The usual type of real estate and rights that we value through the corresponding appraisal report is as follows",
	"Services_text_05": "Acceptance of the order and delivery of necessary documentation",
	"Services_text_06": "Visit to the building by a technician from BARNA-TASA",
	"Services_text_07": "Preparation of the report or reports by BARNA-TASA",
	"Services_text_08": "Delivery of the report in digital format and / or paper",
	"Sign_Up": "Sign Up",
	"Source": "Source",
	"Sports_clubs": "Sports clubs",
	"Sports_facilities": "Sports facilities",
	"Staircase": "Staircase",
	"Standard_deviation_of_the_sample": "Standard deviation of the sample",
	"Storerooms": "Storerooms",
	"Street_name": "Street",
	"Street_number": "Nº",
	"Structure": "Structure",
	"Sun.": "Sun.",
	"Supervisor": "Supervisor",
	"Surnames": "Surnames",
	"Surnames_name": "Surnames, Name",
	"Surroundings": "Surroundings",
	"Surveying": "Surveying",
	"Swimming_pool": "Swimming pool",
	"Tasks": "Tasks",
	"Taxes": "Taxes",
	"technical_values": "technical values",
	"Technical_values": "Technical values",
	"Technology": "Technology",
	"Tenant_age_years": "Tenant's age",
	"Tenant_life_expectancy_years": "Life expectancy",
	"Tenant_remaining_life_expectancy_years": "Tenant's remaining life expectancy",
	"Team_text": "The company is formed by a group of architects, engineers and specialists in appraisals and valuations with a wide knowledge on the real estate market and with an experience of more than 30 years in the field of real estate appraisals and valuations",
	"Teamwork": "Teamwork",
	"Telephone": "Telephone",
	"Telephone_contact": "Telephone contact",
	"telephone_number": "nº de telèfon",
	"Telephone_number": "Telephone nº",
	"Telephone_numbers": "Telephone numbers",
	"Terrain": "Terrain",
	"Testamentary_shares": "Testamentary shares",
	"thousand": "thousand",
	"thousand_euros": "thousand euros",
	"The_company": "The Company",
	"The_page_contains_unsaved_changes": "The current page contains unsaved changes",
	"The_passwords_do_not_match": "The passwords do not match",
	"thousands_of_euros": "thousands of euros (€)",
	"Thu.": "Thu.",
	"TIN": "TIN",
	"Title": "Title",
	"Title_and_date_of_report": "Title and date of report",
	"Title_s_Honorific": "Títle / Honorific",
	"Total_depreciation": "Total depreciation",
	"Total_value": "Total value",
	"Transparency": "Transparency",
	"Trust": "Trust",
	"type": "type",
	"Type": "Type",
	"Type_here_to_filter_paginated_data": "Type here to filter paginated data",
	"Type_of_property": "Type of property",
	"Typical_deviation": "Typical deviation",
	"Typology": "Typology",
	"Uncovered_outdoor_area": "Uncovered outdoor area",
	"Unit_price": "Unit price",
	"Unit_value": "Unit value",
	"universal_sample": "universal sample",
	"Universal_sample": "Universal sample",
	"Updated_reversion_value": "Updated reversion value",
	"Update_type": "Update type",
	"Update_value": "Update value",
	"Update_value_calculation": "Update value calculation",
	"Upper_limit": "Upper limit",
	"Url": "Link",
	"Useful_life": "Useful life",
	"Usufruct": "Usufruct",
	"Usufruct_value": "Usufruct value",
	"Usufructuary_age_years": "Age of the usufructuary",
	"Urban_planning_parameters": "Urban planning parameters",
	"valuated_in_this_report": "valuated in this report",
	"to": "to",
	"total_values": "total values",
	"Total_values": "Total values",
	"Others": "Others",
	"Valuation": "Valuation",
	"Valuation_pricing": "Valuation pricing",
	"Valuation_report": "Valuation report",
	"valuations": "valuations",
	"Valuation_date": "Date of appraisal value",
	"Valuation_purpose": "Valuation purpose",
	"Valuation_type": "Valuation type",
	"Value_date": "Value date",
	"Version": "Version",
	"Visits": "Visits",
	"VAT": "VAT",
	"Warnings": "Warnings",
	"We_are_sorry_c_the_page_you_requested_cannot_be_found": "We're sorry, the page you requested cannot be found",
	"Weighing": "Weighing",
	"Welcome_message": "Welcome to Barnatasa app",
	"What_you_need_to_provide": "What you need to provide",
	"with": "with",
	"without_saving": "without saving",
	"Workflow": "Workflow",
	"Wrong_date_message": "Date is incomplete or wrong",
	"years": "years",
	"You_are_about_to_delete": "You are about to delete",
	"Registry_area": "Registry area",
	"Checked_area": "Checked area",
	"Plot_occupation": "Plot occupation",
	"Plot_free_area_usage": "Use of the plot's free area",
	"Floors_number_underground": "Nª of floors under ground",
	"Floors_number_overground": "Nº of floors over ground",
	"Parking_slots_included_in_appraisal_number": "Nº of parking slots included in the valuation",
	"Entrance_hall": "Entrance hall",
	"Doorman_space": "Doorman space",
	"Community_room": "Community room",
	"Storage_room_included_in_appraisal": "Storage room included in the valuation",
	"Community_parking": "Parking",
	"Facilities_others": "Others",
	"Floors_usage_underground": "Use under ground",
	"Floors_usage_overground": "Use over ground",
	"Groundfloor_usage": "Use ground floor",
	"Real_estates_useful_life": "Real Estate's useful life",
	"Real_estates_total_useful_life": "Property's total useful life",
	"Remaining_useful_life_years": "Remanining useful life years",
	"Urban_and_surroundings_text": "Urban planning and surroundings",
	"Communications": "Communications",
	"Airport": "Airport",
	"Harbour": "Harbour",
	"Train": "Train",
	"Public_transport": "Public transport",
	"Urban_underground": "Urban underground",
	"Interurban": "Interurban",
	"Territorial_feature": "Territorial feature",
	"Income_level": "Income level",
	"Homogeneity_feature": "Homogeneity feature",
	"Main_uses": "Main uses",
	"Density": "Density",
	"Accessibility": "Accessibility",
	"Consolidation_degree": "Consolidation degree",
	"Occupation_degree": "Occupation degree",
	"Evolution": "Evolution",
	"Average_age": "Average age",
	"Commercial": "Commercial",
	"Educational": "Educational",
	"Public_parking": "Public parking",
	"Medical_assistance": "Medical assistance",
	"Leisure": "Leisure",
	"Building_development_level": "Nivell de desenvolupament de l'edificació",
	"Facilities": "Equipaments",
	"MUC_map": "MUC map",
	"Registry": "Registry",
	"Section": "Section",
	"Volume": "Volume",
	"Book": "Book",
	"Page": "Page",
	"Registry_real_estate_number": "Registry Property Nº",
	"Holder": "Holder",
	"Property_coef": "Property coefficient",
	"Bedrooms_and_bathrooms": "Bedrooms and bathrooms",
	"Covered_outdoor_areas": "Covered outdoor areas",
	"Uncovered_outdoor_areas": "Uncovered outdoor areas",
	"Add_covered_outdoor": "Add covered outdoor space",
	"Add_uncovered_outdoor": "Add uncovered outdoor space",
	"Enclosed_area": "Enclosed area",
	"Enclosed_checked_area": "Enclosed checked area",
	"Low_enclosed_checked_area_error_text": "The enclosed checked area is less than the total net area",
	"Proportional_part_of_common_elements": "Proportional part of common elements",
	"Common_elements_cadastral_area": "Common Elements Cadaster",
	"Common_elements_registry_area": "Common Elements Registr)",
	"Common_elements_checked_area": "Common Elements(Checked",
	"Common_elements_adopted_area": "Common Elements Adopted",
	"Total_areas_summary_table": "Total areas summary table",
	"Register": "Registre",
	"Cadaster": "Cadastre",
	"Checked": "Comprobada",
	"Selected": "Seleccionada",
	"Adopted": "Adoptada",
	"Usage": "Usage",
	"Covered_outdoors_area": "Area of covered outdoor spaces",
	"Uncovered_outdoors_area": "Area of uncovered outdoor spaces",
	"Built_plus_common_elements_area": "Built area + Common Elements",
	"Built_plus_common_elements": "Built + Common Elements",
	"Common_elements": "Common elements",
	"Number_of_rooms_to_exterior": "Nº of rooms to exterior",
	"Day_night_zoning": "Day / night zoning",
	"Door_opener": "Door opener",
	"Fitted_cupboards": "Fitted cupboards",
	"Gas": "Gas",
	"Sanitary_fittings": "Sanitary fittings",
	"Taps": "Taps",
	"Hot_water": "Hot water",
	"Fire_prevention": "Fire prevention",
	"Intrusion_prevention": "Intrusion prevention",
	"Foundation": "Foundation",
	"Roof": "Roof",
	"External_enclosures": "External enclosures",
	"Insulation": "Insulation",
	"External_carpentry": "External carpentry",
	"Glazing": "Glazing",
	"Views": "Views",
	"Windows_size_and_quantity": "Size and quantity of windows",
	"Noise_facade": "Noise level on facade",
	"Systems": "Systems",
	"conservation_status": "conservation status",
	"Building_shell": "Building shell",
	"building_shell": "building shell",
	"Shell": "Shell",
	"shell": "shell",
	"Interior_finishes": "Interior finishes",
	"Living": "Living",
	"Kitchen": "Kitchen",
	"Walls": "Walls",
	"Ceilings": "Ceilings",
	"Interior_carpentry": "Interior carpentry",
	"Circulations": "Circulations",
	"BdE_files": "BdE Files",
	"Construction_prices": "Construction costs",
	"Add_bec_property": "Add Real Estate Type",
	"Add_bec_number": "Add B.E.C. nº",
	"Year": "Year",
	"Quarter": "Quarter",
	"Bec_adjustment_coef": "B.E.C. Adjustment coeficient",
	"Adjusted_bec_price": "Adjusted B.E.C. price.",
	"Expenses_and_industrial_benefit_bec_pct": "Percentage of expenses and industrial benefit",
	"Construction_status": "Construction status",
	"Construction_cost_notes": "Notes on the construction cost",
	"Mandatary": "Mandatary",
	"Mandatary_entity": "Mandatary entity",
	"Acc_mortgage_market_law_q": "is it following the mortgage market law?",
	"Acc_eco_decree_q": "is it following the ECO/805/2003 decree?",
	"location": "location",
	"Registry_property": "Registry property",
	"Cadastral_file": "Cadastral File",
	"Nucleus_area": "Municipality area",
	"Nucleus_type": "Type of nucleus",
	"Locality": "Locality",
	"Employment_occupation": "Employment occupation",
	"Population": "Population",
	"Population_density": "Population density",
	"Population_growth": "Population growth",
	"Last_year": "Last year",
	"Terrain_description": "Terrain description",
	"Terrain_infrastructures": "Terrain infrastructures",
	"Execution": "Execution",
	"Water_supply": "Water supply",
	"Terrain_area": "Terrain area",
	"Site_quality": "Site quality",
	"Underground_levels": "Underground levels",
	"Ground_level": "Ground level",
	"Overground_levels": "Overground levels",
	"Building_description": "Building description",
	"Checkings_realized": "Comprovacions realitzades",
	"Documents_used": "Documentació utilitzada",
	"Interior_visit": "Visita interior de l'immoble",
	"Expropriation_procedure": "Procediment d'expropiació",
	"Expropriation_plan": "Pla o projecte d'expropriació",
	"Expropriation_admin_ruling": "Resolució administrativa expropiació",
	"Expropriation_file": "Expedient d'expropriació",
	"Occupancy": "Estat d'ocupació i ús",
	"Servitudes": "Servituds",
	"Public_protection_regime": "Règim de protecció pública",
	"Urban_paramaters_suitability": "Adequació al planejament urbanístic",
	"Another": "Another",
	"Approved_project_by_professional_association": "Projecte visat pel col·legi professional",
	"Cadastral_documents": "Documentació cadastral",
	"Construction_license": "Llicència de construcció",
	"Construction_last_certificate": "Últim certificat de construcció",
	"Construction_contract": "Contracte de construcció",
	"Occupancy_status": "Estat d'ocupació",
	"Photographic_report": "Reportatge fotogràfic",
	"Property_sketch": "Croquis de l'immoble",
	"Property_titles": "Document de propietat segons normativa",
	"Situation_plan": "Plànol de situació",
	"Ten_year_insurance": "Assegurança decennal",
	"Urban_plan": "Plànol urbanístic",
	"Habitability_conditions": "Habitability conditions",
	"Main_orientation": "Main orientation",
	"Property_title": "Property_title",
	"Usage_assigned": "Usage_assigned",
	"Usage_assigned_by_the_owner": "Usage assigned by the owner",
	"Inspection_realized": "Inspection realized",
	"Economical_activity": "Economical activity",
	"Real_rights": "Real rights",
	"Bulletin_number": "Bulletin nº",
	"a": "a",
	"Select": "Select",
	"Market_data": "Market data",
	"Market_samples": "Market samples",
	"Offer_date": "Offer date",
	"Sample": "Sample",
	"Market_analysis": "Market analysis",
	"Prices_estimated_yearly_evolution_pct": "Prices - annual evolution, estimated variation (%)",
	"Market_value_evolution_probability_pct": "Forecast evolution of the comparison value (%)",
	"Offer_production": "Offer - production",
	"Offer_yearly_stock": "Offer - Annual stock",
	"Offer_trend": "Offer - trend",
	"Demand_level": "Demand - level",
	"Demand_speed_of_sales": "Demand - speed of sales",
	"Demand_trend": "Demand - trend",
	"Prices_expectancy": "Prices - Expectation",
	"Prices_past_cicles_volatility": "Expectation - Volatility of past cycles",
	"Market_conjuncture": "Market conjuncture",
	"Market_value_reduction_probability_expectancy": "Expectation - Probability of reduction of the comparison value",
	"Offer": "Offer",
	"Demand": "Demand",
	"Expectation": "Expectation",
	"Maximum": "Maximum",
	"Minimum": "Minimum",
	"Mean": "Mean",
	"Median": "Median",
	"Market_prices": "Market prices",
	"Neighbourhood": "Neighbourhood",
	"Situation": "Situation",
	"Samples": "Samples",
	"Similarities": "Similarities",
	"Statistical_deviations": "Statistical deviations",
	"Typical_deviation_of_the_sample": "Typical deviation of the sample",
	"Technical_values_calculation": "Technical values calculation",
	"Material_execution_cost_as_new": "Material execution cost (as new)",
	"Finished_building_market_value": "Finished building market value",
	"finished_building": "finished building",
	"Total_values_calculation": "Total values calculation",
	"year": "year",
	"Other_values": "Other values",
	"Appraisal_value_determination_text": "In accordance with the criteria set in the ECO 805/2003 order, the applicable value is:",
	"Add_constraint": "Add constraint",
	"Add_warning": "Add warning",
	"Add_note": "Add note",
	"Constraints": "Constraints",
	"Constraints_foreseen_by_law": "Constraints foreseen by Law",
	"Warnings_foreseen_by_law": "Warnings foreseen by Law",
	"Notes_foreseen_by_barnatasa": "Notes foreseen by BARNA-TASA S.A.",
	"English": "English",
	"Spanish": "Spanish",
	"The_Real_Estate_is_not_protected": "The Real Estate is nor protected",
	"The_Real_Estate_is_not_rented_or_ceded": "The Real Estate is not rented or ceded",
	"There_is_no_cession_of_the_right_of_use": "There is no cession of the right of use",
	"The_value_is_not_calculated": "The value is not calculated",
	"Elements_included_in_this_valuation": "Elements included in this valuation",
	"Market_value_adjustment_pct": "Market value adjustment percentage",
	"Constraint": "Constraint",
	"Warning": "Warning",
	"Note": "Note",
	"Upload_photographs": "Upload photographs",
	"Photograph": "Photograph",
	"Photographs": "Photographs",
	"Image_footer": "Image footer",
	"Upload_files": "Upload files",
	"File_name": "File name",
	"in": "in",
	"Registry_Documents": "Registry Documents",
	"Cadastral_Documents": "Cadastral Documents",
	"Plans": "Plans",
	"Sketches": "Sketches",
	"Cession_Documents": "Cession Documents",
	"Contracts": "Contracts",
	"Other_Documents": "Other Documents",
	"with_date": "on date of",
	"Date_of_issue": "Date of issue",
	"Signatures": "Signatures",
	"Report_date_of_issue": "Report date of issue",
	"Professional_that_visited_the_property": "Professional that visited the property",
	"Date_of_visit": "Date of visit",
	"Appraisers": "Appraisers",
	"Supervisors": "Supervisors",
	"Appraisers_Index": "Index of Appraisers",
	"Supervisors_Index": "Index of Supervisors",
	"Add_appraiser": "Add appraiser",
	"Add_supervisor": "Add supervisor",
	"Prof_assoc_reg_number": "Nº col·legiat",
	"Visit_date": "Visit date",
	"Technician_who_performed_the_visit": "Technician visiting",
	"Visit": "Visit",
	"Floor_name": "Floor name",
	"Import_comparable_set": "Import comparable set",
	"Import_comparable_set_from_another_market_study": "Import comparable set from another market study",
	"There_are_unsaved_changes": "There are unsaved changes",
	"Unsaved_data_will_be_lost": "Unsaved data will be lost",
	"Cover": "Cover",
	"Annexed_documents": "Annexed documents",
	"Photographies": "Photographies",
	"Report_of": "Report of",
	"correlated_pages_numbered_from": "correlated pages, numbered from",
	"technician": "technician",
	"Sanitary_fittings_quality": "Quality of sanitary fittings",
	"Taps_quality": "Quality of taps",
	"Land_selected_area": "Selection method",
	"Urban_parameters_suitability": "Suitability to the urban planning parameters",
	"Maps": "Maps",
	"Situation_maps": "Situation maps",
	"Other": "Other",
	"Subsidy_status": "Public protection qualification",
	"Quote": "Quote",
	"Appraisal_quote": "Appraisal quote",
	"Appraisal_quotes": "Appraisal quotes",
	"Add_appraisal_quote": "Add new appraisal quote",
	"Title_and_date_of_quote": "Title and date of quote",
	"valuated_in_this_quote": "valuated in this quote",
	"Quote_title_missing_error_text": "The quote title is missing",
	"Print_quote_in_PDF": "Print quote in PDF",
	"Create_new_real_estate": "Create new Real Estate",
	"Select_Real_estate_to_be_added": "Select Real Estate to be added",
	"Existing_Real_estates": "Existing Real Estates in database",
	"create_a_new_one": "create a new one",
	"staircase": "staircase",
	"block": "block",
	"door": "door",
	"Full_address": "Full address",
	"Status": "Status",
	"Quote_number": "Nº de presupuesto",
	"Quote_content": "Contenido del presupuesto",
	"Quote_title": "Quote title",
	"Travel_expenses": "Travel expenses",
	"Travel_one_way_hours": "Travel hours (one way)",
	"Travel_both_ways_hours": "Travel hours (both ways)",
	"Travel_fees_per_hour": "Travel fees per hour",
	"Total_car_expenses_one_way": "Travel expenses (one way)",
	"Total_car_expenses_both_ways": "Travel expenses (both ways)",
	"Total_travel_fees": "Total travel fees",
	"Quote_area_average_unit_price": "Area average price (€/m2)",
	"Quote_base_fees": "Base fees",
	"Quote_excess_pct": "% excess from base fees",
	"Quote_base_price": "Total fees",
	"Quote_base_price_coef": "Adjustment coef.",
	"Valuation_quote": "Valuation quote",
	"Appraisal_cost": "Appraisal cost",
	"Appraisal_fees": "Appraisal fees",
	"Appraisal_price": "Appraisal price",
	"hours": "hours",
	"Area_prices": "Prices of this area",
	"Area_average_unit_price": "Average price of this area",
	"Ads_date_range": "Ads date range",
	"Current_area_prices": "Current area prices",
	"pre_appraisal": "pre-appraisal",
	"Pre_appraisal": "Pre-appraisal",
	"Estimated_built_area": "Estimated built area",
	"Pre_appraisal_value": "Pre-appraisal value",
	"Area_average_price_coef": "Price adjustment coefficient",
	"Adopted_area_average_price": "Adopted unit price",
	"Car_fuel_expenses_one_way": "Fuel expenses (one way)",
	"Car_fuel_expenses_both_ways": "Fuel expenses (both ways)",
	"Car_toll_expenses_one_way": "Toll expenses (one way)",
	"Car_toll_expenses_both_ways": "Toll expenses (both ways)",
	"Valuation_pricing_info_table": "Valuation pricing info table",
	"Check_prices": "Check prices",
	"Add_ad_manually": "Ad new add manually",
	"Ads_index": "Ads index",
	"Go_back_to_market_study": "Go back to market study",
	"Offer_price_reduction_coef": "Price reduction coefficient",
	"Cession_files": "Lease files",
	"Lease": "Lease",
	"Gross_tax_per_1000_inhabitants": "Gross tax per 1000 inhabitants",
	"Site": "Site",
	"Urban_planning": "Urban planning",
	"Construction_description": "Construction description",
	"Status_on_occupancy_protection_cession_usage_and_real_rights": "Occupancy status, protection regime, cession, usage and real rights",
	"Real_rights_protection_and_occupation": "Real rights, protection and occupation",
	"PA_number": "Prof. registration nº",
	"Quote_petitioner": "Quote petitioner",
	"Quote_petitioners": "Quote petitioners",
	"Dear": "Dear",
	"Dear_m": "Dear",
	"Dear_f": "Dear",
	"Quote_sentence_01": "We are pleased to attach the Fees Budget for the Appraisal Report of the following Real Estates:",
	"Approx_area": "Approx. area",
	"Signed": "Signed",
	"Amount_money": "Amount",
	"Total_cost_including_VAT": "Total cost (VAT included)",
	"Fiscal_parameters": "Fiscal parameters",
	"VAT_pct": "VAT (%)",
	"Quote_sentence_02": "Payment conditions: 50% on start and 50% on the delivery of the Appraisal Reports",
	"Quote_sentence_03": "Bank transfer to",
	"Quote_sentence_04": "Tasks to do in order to prepare the Appraisal Reports",
	"Quote_sentence_05": "Visit of the Real Estate by a technician, Architect/Engineer from BARNA-TASA",
	"Quote_sentence_06": "Making of the Appraisal Report. Content",
	"Payment_details": "Payment details",
	"Required_documentation": "Required documentation",
	"Quote_sentence_07": "Delivery of the reports in digital form (PDF)",
	"Quote_sentence_08": "If a paper version is required, an additional cost of 15 € will be applied for the printing and post delivery",
	"Quote_sentence_09": "Petitioner's name, tax nº and address",
	"Quote_sentence_10": "Invoice details: name, tax nº and address",
	"Quote_sentence_11": "Copy of the property deeds",
	"Quote_sentence_12": "Copy of the IBI tax receipt (Cadastral data) (optional)",
	"Quote_sentence_13": "Copy of the rental contract and an updated receipt (if under rent)",
	"Quote_sentence_14": "Purpose of the appraisal (buy/sell, mortgage guarantees, ...)",
	"Quote_sentence_15": "Name and telephone number of the contact person in order to visit the property",
	"Quote_sentence_16": "Plans/architectural drawing of the property (optional)",
	"At_your_disposal_for_any_clarification": "At your disposal for any clarification",
	"Kindest_regards": "Kindest Regards",
	"CFO_CHRO_female": "Chief Financial and Human Resources Officer",
	"Additional_costs": "Other costs",
	"Quote_sentence_17": "In the event of assistance of the technician in court to ratify the report the cost will be 150 € + VAT",
	"Quote_sentence_18": "The report will be delivered in digital form (PDF). If a paper version is needed the cost will be 15 €, under the concept of printing and post delivery",
	"Appraisal_invoice": "Invoice",
	"Appraisal_invoices": "Invoices",
	"Add_appraisal_invoice": "Add invoice",
	"Title_and_date_of_invoice": "Title and date of invoice",
	"valuated_in_this_invoice": "valuated in this invoice",
	"Invoice_title_missing_error_text": "Invoice title is missing",
	"Print_invoice_in_PDF": "Print invoice in PDF",
	"Valuation_invoice": "Invoice",
	"Invoice": "Invoice",
	"Client": "Client",
	"Invoice_number": "Invoice nº",
	"Invoice_content": "Invoice content",
	"Invoice_title": "Invoice title",
	"Add_petitioner": "Add petitioner",
	"Create_new_contact": "Create new contact",
	"No_petitioners_text": "No contacts added. Please, select from the list and click on 'add petitioner'",
	"Surnames_name_or_company": "'Surnames, Name' or 'Company name'",
	"No_records": "No records",
	"Quotes_requested_by": "Quotes requested by",
	"Dear_sir_or_madam": "Dear Sir/Madam",
	"Dear_sirs_or_madams": "Dear Sirs/Madams",
	"Dear_sir": "Dear Sir",
	"Dear_madam": "Dear Madam",
	"Dear_sirs": "Dear Sirs",
	"Dear_madams": "Dear Madams",
	"Dear_madams_and_sirs": "Dear Madams and Sirs",
	"Dear_madam_and_sir": "Dear Madam and Sir",
	"Dear_pl": "Dear",
	"Dear_pl_f_m": "Dear",
	"Dear_pl_f": "Dear",
	"Dear_pl_m": "Dear",
	"Main_email": "Main e-mail address",
	"Add_other_email": "Add other e-mail",
	"Complete_name": "Complete_name",
	"Payment_conditions": "Payment conditions",
	"Note_w": "Note",
	"Final_price": "Final price",
	"Discount_pct": "Discount (%)",
	"Discount_notes": "Notes on the discount",
	"Bank_name": "Bank name",
	"Court_assistance_fees": "Court attendance fees",
	"Required_docs": "Required doc",
	"Documentation_type": "Documentation type",
	"Add_required_doc": "Add to the list",
	"Document": "Document",
	"Petitioners_missing_error_text": "Falta indicar el sol·licitant de pressupost",
	"Realestates_missing_error_text": "Falta indicar els immobles del pressupost",
	"Requireddocs_missing_error_text": "Falta indicar la documentació necessària",
	"Discount": "Discount",
	"Fees_incl_discount": "Fees including discount",
	"Quote_reference": "Quote reference for this invoice",
	"Invoice_lines": "Invoice lines",
	"Add_invoice_line": "Add invoice line",
	"Units": "Units",
	"Import_quote_concepts": "Importar concepts from quote",
	"invoice": "invoice",
	"line": "line",
	"Lines_missing_error_text": "Falta introduir els conceptes de la factura",
	"Concept": "Concept",
	"Add_client": "Add client",
	"Appraisal_invoice_description": "Descripction of the invoice",
	"Invoice_to": "Invoice to",
	"Emited_by": "Emited by",
	"Invoice_Total": "Invoice Total",
	"Emmission_date": "Emmission date",
	"Reference": "Reference",
	"Appraisal_invoices_index": "Index of Invoices",
	"Appraisal_quotes_index": "Index of Quotes",
	"Invoice_fiscal_number": "Invoice Fiscal Nº",
	"Billing": "Billing",
	"invoice_fiscal_number": "invoice fiscal nº",
	"Last_m": "Last",
	"invoice_number": "invoice",
	"Last_created_invoice": "Last created invoice",
	"Welcome": "Welcome",
	"Ad_description": "Ad description",
	"Upload_to_database": "Save and upload to database",
	"Address_referral": "Address referral",
	"Max_distance": "Max. distance",
	"Print_report_s_certificate_in_PDF": "Print Report/Certificate in PDF",
	"Appraisal_certificate": "Appraisal certificate",
	"Certificate_text_01": "Ferran López-Doriga Fontcuberta, Architect, Director and Technical Supervisor of BARNA-TASA, S.A., registered company in the Registro Oficial de Sociedades de Tasación del Banco de España, nº 4.470 and inscription date June 26th 1.995,",
	"Certificate_text_02": "That with File nº",
	"Certificate_text_03": "a valuation report has been made on date",
	"Certificate_text_04": "and the valuation contains the following data",
	"Certificate_text_05": "I hereby sign the present certificate in Barcelona, ",
	"certifies": "certifies",
	"Petitioner_TIN": "Petitioner's Tax Id. Nr",
	"Petitioner_address": "Address of the Petitioner",
	"registered_in": "registered en",
	"from_the": "from the",
	"Method_used_to_calculate_the_value": "Method used to calculate the adopted_value",
	"Cost_value_current_state": "Cost value in the current state",
	"Comparison_value": "Comparison value",
	"Maximum_legal_value": "Maximum legal value",
	"Adjusted_market_value": "Adjusted market value",
	"Total_appraisal_value": "Total appraisal value",
	"Real_estates_missing_error_text": "No Real Estates have been added to this report",
	"Sign_quote": "Sign quote",
	"Sign_appraisalreport": "Sign report",
	"Appraiser_sign_appraisalreport": "Sign report (Appraiser)",
	"Supervisor_sign_appraisalreport": "Sign report (Supervisor)",
	"Sign_invoice": "Sign invoice",
	"Sign_certificate": "Sign certificate",
	"Signature": "Signature",
	"Appraisers_signature": "Signature of the Appraiser",
	"Supervisors_signature": "Signature of the Supervisor",
	"Main_telephonenumber": "Main telephone nº",
	"with_purpose": "with purpose",
	"Purpose": "Purpose",
	"Prices": "Prices",
	"BEC_expenses_plus_builders_benefit_pct": "% of expenses and builders benefit included in BEC's price",
	"pkg_number": "Parking-spot Nº",
	"Index": "Index",
	"Cession_type": "Cession type",
	"Real_right_type": "Real Right Type",
	"Reports": "Reports",
	"Other_files": "Other files",
	"Construction_reposition_cost_as_new": "Construction reposition cost as new",
	"Construction_value_in_actual_state": "Value of the construction in actual state",
	"executed_construction": "executed construction",
	"Integrity": "Integrity",
	"remaining": "remaining",
	"or": "or",
	"Project": "Project",
	"Projects": "Projects",
	"Add_project": "Add project",
	"Projects_of_the_Real_Estate": "Projects",
	"BDE_files_index": "BDE files index",
	"BDE_files": "BDE files",
	"Asset_type": "Asset type",
	"Property_usage": "Usage of the property",
	"Parking_spots_included_number": "Nº of parking spots included",
	"BdE_appraisal_files": "Appraisals",
	"BdE_realestate_files": "Real Estates",
	"BdE_comparable_files": "Comparables",
	"BdE_relationships_files": "Relationships",
	"Insurance_value_rd_1982_text": "Gross replacement cost excluding the value of the land",
	"Insurance_value_rd_2009_text": "Appraisal value excluding the value of the land",
	"VAT_not_included": "VAT not included",
	"EEC_conditions": "Dwellings up to 100 sqm in Barcelona's Metropolitan Area: 125 €+ IVA",
	"OCC_conditions": "Dwellings up to 100 sqm in Barcelona's Metropolitan Area: 125 €+ IVA",
	"EECOCC_conditions": "Dwellings up to 100 sqm in Barcelona's Metropolitan Area: 210 €+ IVA",
	"OT_conditions": "Altres tipologies segons pressupost"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 2282
// module chunks = 0